import { render, staticRenderFns } from "./build_service.vue?vue&type=template&id=0468802c&scoped=true"
import script from "./build_service.vue?vue&type=script&lang=js"
export * from "./build_service.vue?vue&type=script&lang=js"
import style0 from "./build_service.vue?vue&type=style&index=0&id=0468802c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0468802c",
  null
  
)

export default component.exports